import { useSupabaseAuthProviderService } from '../../../services/supabase-auth-provider.service';

export const refreshSession = async () => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error('Supabase client not found');
  }

  return supabaseClient.auth.refreshSession();
};

export const signOut = async () => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error('Supabase client not found');
  }

  return supabaseClient.auth.signOut({ scope: 'local' });
};

export const signInWithSSO = async (
  ssoProviderId: string,
  redirectTo: string,
) => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error('Supabase client not found');
  }

  return supabaseClient.auth.signInWithSSO({
    providerId: ssoProviderId,
    options: {
      redirectTo,
    },
  });
};

export const setSession = async (accessToken: string, refreshToken: string) => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error('Supabase client not found');
  }

  return supabaseClient.auth.setSession({
    access_token: accessToken,
    refresh_token: refreshToken,
  });
};

export default {
  refreshSession,
  signOut,
  signInWithSSO,
  setSession,
};
